import React from "react";

const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DateUtility = {
  FormatTime: (date) => {
    //input ==> js date object
    //output 23:30
    date = new Date(date);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

    return formattedTime;
  },
  ConvertCETtoCurrentTimeZoneCounter: (utc_datetime, offset) => {
    // input: "2023-06-13 10:00:00"
    // output: "2023-06-13 23:30:00"

    const localDate = new Date(utc_datetime.replace(" ", "T"));
    // ensure valid ISO string for JS Date

    const timezoneOffset = offset * 60; // offset in hours → minutes
    localDate.setMinutes(localDate.getMinutes() + timezoneOffset);

    // format YYYY-MM-DD HH:mm:ss
    const pad = (n) => String(n).padStart(2, "0");

    const year = localDate.getFullYear();
    const month = pad(localDate.getMonth() + 1);
    const day = pad(localDate.getDate());
    const hours = pad(localDate.getHours());
    const minutes = pad(localDate.getMinutes());
    const seconds = pad(localDate.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },
  ConvertCETtoCurrentTimeZoneDate: (utc_datetime, offset) => {
    if (!utc_datetime) return "";
    const localDate = new Date(utc_datetime.replace(" ", "T"));
    if (isNaN(localDate.getTime())) return "";
    const timezoneOffset = (offset || 0) * 60;
    localDate.setMinutes(localDate.getMinutes() + timezoneOffset);

    const pad = (n) => String(n).padStart(2, "0");

    const year = localDate.getFullYear();
    const month = pad(localDate.getMonth() + 1);
    const day = pad(localDate.getDate());

    return `${year}-${month}-${day}`;
  },

  //Input ===>"2023-06-13 10:00:00", 5(difference)
  //Output ===>"2023-06-13"

  ConvertCETtoCurrentTimeZone: (utc_datetime, offset) => {
    //input ==> 2023-06-13 10:00:00
    //output 23:30
    const localDate = new Date(utc_datetime);
    const timezoneOffset = offset * 60;
    localDate.setMinutes(localDate.getMinutes() + timezoneOffset);

    const res = localDate.toLocaleString("en-US", {
      hour12: false,
    });
    let result = `${res?.split(" ")[1]?.split(":")[0]}:${res?.split(" ")[1]?.split(":")[1]}`;
    return result;
  },
  dateFormat1: (datee, month = "long") => {
    //input: '2023-05-25T00:00:00.000000Z'
    //output:  25 May
    if (!datee) return "";
    const dateObj = new Date(datee);
    const formattedDate = dateObj.toLocaleDateString("en-GB", {
      day: "numeric",
      month: month,
    });
    return formattedDate;
  },
  FormatDate: (date) => {
    //input ==> 2023-06-13 10:00:00
    // Output: "Thu 15 Jun 2023"
    if (!date) return "";
    date = new Date(date);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthsOfYear = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayOfWeek = daysOfWeek[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${dayOfWeek}, ${dayOfMonth} ${month} ${year}`;

    return formattedDate;
  },
  GetCurrentDateAsString: () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // January is month 0
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  },
  ConvertDate: (date) => {
    const year = date.toLocaleString("default", { year: "numeric" });
    const month = date.toLocaleString("default", { month: "2-digit" });
    const day = date.toLocaleString("default", { day: "2-digit" });
    let myDate = `${year}-${month}-${day}`;
    return myDate;
  },
  ConvertDate1: (date) => {
    // input '2023-07-17 14:10:00'
    // Output: 2023-07-17
    const dateTimeString = date;
    const dateObject = new Date(dateTimeString);
    const dateOnly = dateObject.toISOString().split("T")[0];
    return dateOnly || "";
  },
  FormatDateListing: (date) => {
    //input ==> 2023-06-15
    //output ==> Thu, 15 June
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "Sept",
      "October",
      "November",
      "December",
    ];

    const currentDate = new Date(date);
    const dayOfWeek = daysOfWeek[currentDate.getDay()];
    const day = currentDate.getDate();
    const month = months[currentDate.getMonth()];

    const formattedDate = `${dayOfWeek}, ${day} ${month}`;

    return formattedDate;
  },
  FormatDateListing1: (date) => {
    // input ==> 2023-06-15
    // output ==> 06/15

    const currentDate = new Date(date);

    // Get the month and date
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // +1 as months are 0-indexed
    const day = String(currentDate.getDate()).padStart(2, "0"); // pad with 0 for single digits

    const formattedDate = `${month}/${day}`;

    return formattedDate;
  },
  dateFormat9: (datee) => {
    //input: '2023-05-25T00:00:00.000000Z'
    //output: May 25, 2023
    if (!datee) return "";
    const dateObj = new Date(datee);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    return formattedDate;
  },
  CurrentDateAddRem1: (curDate, sign, val = 1) => {
    if (!curDate || !sign) return;
    let date = new Date(curDate);
    sign === "+"
      ? date.setDate(date.getDate() + val)
      : date.setDate(date.getDate() - val);
    const year = date.getFullYear();
    let month = date.getMonth();
    month = month + 1;
    let day = date.getDate();
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }

    return `${year}-${month}-${day}`;
  },
  CurrentDateAddRem: (sign = "+", val = 0) => {
    let date = new Date();
    sign === "+"
      ? date.setDate(date.getDate() + val)
      : date.setDate(date.getDate() - val);
    const year = date.getFullYear();
    let month = date.getMonth();
    month = month + 1;
    let day = date.getDate();
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }

    const data = {
      date: `${year}-${month}-${day}`,
      day: Number(day) || "",
      weekDay: daysOfWeek[date.getDay()] || "",
    };

    return data;
  },
  FormatDateh2h: (date) => {
    const options = { day: "numeric", month: "short" };
    return date.toLocaleDateString("en-US", options);
  },
  get30Dates: () => {
    const today = new Date();
    const dates = [];

    for (let i = -30; i <= 30; i++) {
      const currentDate = new Date();
      currentDate.setDate(today.getDate() + i);

      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const weekDay =
        i === 0 ? "Today" : daysOfWeek[currentDate.getDay()] || "";

      dates.push({
        date: `${year}-${month}-${day}`,
        day: Number(day) || "",
        weekDay: weekDay,
      });
    }

    return dates;
  },
  dayFromDate: (myDate) => {
    // return current day from date
    const today = myDate ? new Date(myDate) : new Date();
    const day = String(today.getDate()).padStart(2, "0");
    return day;
  },
  checkDateTimeIsLess: (myDate) => {
    // check whether the given time is less than current time or not
    const dated = myDate ? new Date(myDate) : new Date();
    const currentDate = new Date();

    return dated < currentDate;
  },
  formatTo12HourTime(dt) {
    //input: 2025-06-26 18:00:00
    // Outputs: 06:00 PM
    const date = new Date(dt);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${hours.toString().padStart(2, "0")}:${minutesStr} ${ampm}`;
  },
  formatDateTime(dateTime) {
    const date = new Date(dateTime);

    // Format as DD/MM/YYYY - HH:mm
    const formattedDate = date.toLocaleDateString("en-GB"); // dd/mm/yyyy
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${formattedDate} - ${formattedTime}`;
  },
};

// export default DateUtility;
